<ion-header>
  <ion-toolbar color="tertiary">
    <ion-title>Select a Region</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  @for (region of getRegions; track trackByRegion($index, region)) {
  <ion-card>
    <ion-card-header>
      <ion-card-title
        >{{ region.value.region }} @for (flag of region.value.flags; track flag)
        {
        <span class="fi fi-{{ flag }}"></span>
        }</ion-card-title
      >
      <ion-card-subtitle>{{
        region.value.countries.join(" / ")
      }}</ion-card-subtitle>
    </ion-card-header>
    @if (auto_detected_region == region.value.region) {
    <ion-card-content>
      <ion-text color="tertiary"> {{ region.value.description }} </ion-text>
    </ion-card-content>
    }
    <div class="ion-text-end" style="border-top: 1px solid whitesmoke">
      <ion-button
        fill="outline"
        (click)="onSelectRegion($event, region.value.region)"
        (touchend)="onSelectRegion($event, region.value.region)"
        >Select {{ region.value.region }}</ion-button
      >
    </div>
  </ion-card>
  }
</ion-content>
